/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import { useSelector } from 'react-redux';
import {useNavigate } from 'react-router-dom';

const MilestoneMessageCard = ({ data, index, milestoneData, isDraft }) => {
	const [{ LoginData }] = useSelector((state) => [state.user]);
	const sender = data?.senderId === LoginData?.uuid;
	const navigate = useNavigate();
  	const reDirect=()=>{
      if(LoginData.isCustomer){
      	navigate(`/dashboard/projects/${milestoneData?.job_uuid}`)
      }else{
        navigate(`/dashboard/jobs/${milestoneData?.job_uuid}`)
      }
    }

return (
  <div
    className={
      sender
        ? "bg-dark text-white  chat-item d-flex flex-column message-width"
        : "bg-primary  bg-opacity-10  chat-item d-flex flex-column w-75 message-width"
    }
  >
    <font
      style={{ width: "fit-content" }}
      className={
        sender
          ? "bg-dark text-white px-3 py-2 chat-item text-break fold-Text-small message-width"
          : "bg-primary bg-opacity-10 px-3 py-2 chat-item text-break fold-Text-small message-content message-width"
      }
    >
      {milestoneData?.milestone_action === "create-contract" ? (
        <>
          <p>
            Gather and review all relevant financial documents, including income
            statements, deductions, receipts, and previous tax filings. Conduct
            an initial assessment of tax liabilities and identify potential
            deductions or credits.
          </p>
          <div className="milesstone-message-bg">
            <div className="message-innerBox rounded-2 px-3 py-2">
              {!isDraft && milestoneData?.milestones?.length > 0 && milestoneData?.milestones.map((v) => (
                <>
                  <div className="d-flex gap-2">
                    {!isNaN(parseInt(v?.amount)) && (
                      <>
                        <div className="ff-alshaus-bold text-grey-500 p-0 m-0">
                          Total cost:
                        </div>
                        <span className="text-grey-500 p-0 m-0">
                          ${parseInt(v?.amount)}
                        </span>
                      </>
                    )}
                  </div>
                  <div className="d-flex gap-2">
                    {v?.name && (
                      <div className="ff-alshaus-bold text-grey-500 m-0">
                        Milestone:
                      </div>
                    )}
                    {v?.name && (
                      <span className="text-grey-500">{v?.name}</span>
                    )}
                  </div>
                  <div className="d-flex gap-2">
                    {moment(v?.dueDate).isValid() && (
                      <>
                        <p className="ff-alshaus-bold text-grey-500">
                          Due date:
                        </p>
                        <span className="text-grey-500">
                          {moment(v.dueDate).format("D MMM YYYY")}
                        </span>
                      </>
                    )}
                  </div>
                </>
              ))}

              <div
                onClick={reDirect}
                className="ff-alshaus-bold  cursor-pointer"
                style={{ color: "#4C56E7" }}
              >
                View Contract
              </div>
            </div>
          </div>
        </>
      ) : milestoneData?.milestone_action === "contract_signed" ||
        milestoneData?.milestone_action === "contract-update" ? (
        <div className="milesstone-message-bg">
          <div className="message-innerBox rounded-2 px-3 py-2">
            {milestoneData?.service && (
              <div className="d-flex gap-2">
                <div className="ff-alshaus-bold text-grey-500 p-0 m-0">Service:</div>
                <span className="text-grey-500 p-0 m-0">{milestoneData?.service}</span>
              </div>
            )}
            {milestoneData?.milestones?.length > 0 && milestoneData?.milestones.map((v, i) => (
              <div key={i}>
                <div className="d-flex gap-2">
                  {!isNaN(parseInt(v?.amount)) && (
                    <>
                      <div className="ff-alshaus-bold text-grey-500 p-0 m-0">Total cost:</div>
                      <span className="text-grey-500 p-0 m-0">
                        ${parseInt(v?.amount)}
                      </span>
                    </>
                  )}
                </div>
                {v?.name && (
                  <div className="d-flex gap-2">
                    <div className="ff-alshaus-bold text-grey-500 m-0">Milestone:</div>
                    <span className="text-grey-500">{v?.name}</span>
                  </div>
                )}
                {moment(v?.dueDate).isValid() && (
                  <div className="d-flex gap-2">
                    <p className="ff-alshaus-bold text-grey-500">Due date:</p>
                    <span className="text-grey-500">{moment(v.dueDate).format("D MMM YYYY")}</span>
                  </div>
                )}
              </div>
            ))}
            <div
              onClick={reDirect}
              className="ff-alshaus-bold cursor-pointer"
              style={{ color: "#4C56E7" }}
            >
              View Contract
            </div>
          </div>
        </div>
      ) : (
        <div className="milesstone-message-bg">
          <div className="message-innerBox rounded-2 px-3 py-2">
            <div className="d-flex gap-2">
              <p className="ff-alshaus-bold text-grey-500">Milestone cost:</p>
              <span className="text-grey-500">$ {milestoneData?.amount}</span>
            </div>
            <div className="d-flex gap-2">
              <p className="ff-alshaus-bold text-grey-500">Milestone:</p>
              <span className="text-grey-500">{milestoneData?.name} </span>
            </div>
            <div className="d-flex gap-2">
              <p className="ff-alshaus-bold text-grey-500">Due date:</p>
              <span className="text-grey-500">
                {moment(milestoneData?.due_date).format("D MMM YYYY")}
              </span>
            </div>
            <a
              onClick={reDirect}
              href=""
              className="ff-alshaus-bold text-decoration-none"
              style={{ color: "#4C56E7" }}
            >
              View Details
            </a>
          </div>
        </div>
      )}
    </font>
  </div>
);
};
export default MilestoneMessageCard;
